<span class="badge-flag-wrapper">
  <img class="badge-flag-image" src="{{ countryCode }}" />
</span>
